export const LicensingAuthorityStateWiseDetails = {
    "Abu Dhabi": {
        "Mainland": ["Department of Economic Development - Abu Dhabi"],
        "Free Zone": [
            "Abu Dhabi Airport Free Zone (ADAFZ)",
            "Abu Dhabi Global Market (ADGM)",
            "Abu Dhabi Ports Company (ADPC)",
            "Higher Corporation for Specialized Economic Zones (HCSEZ) (ZonesCorp)",
            "Industrial City of Abu Dhabi 1 (ICAD)",
            "Industrial City of Abu Dhabi 2 (ICAD)",
            "Khalifa Industrial Zone Abu Dhabi (KIZAD)",
            "Khalifa Port and Industrial Zone (KPIZ)",
            "twofour54",
            "Masdar City",
            "Abu Dhabi Airport Business City",
            "Abu Dhabi Free Zone",
            "Media Zone Authority - Abu Dhabi"
        ]
    },
    "Ajman": {
        "Mainland": [
            "Department of Economic Development - Ajman",
            "Department of land & real estate regulation of Ajman"
        ],
        "Free Zone": [
            "Ajman Free Zone",
            "Ajman Media City Free Zone"
        ]
    },
    "Dubai": {
        "Mainland": [
            "Department of Economic Development - Dubai",
            "Department of Tourism and Commerce Marketing"
        ],
        "Free Zone": [
            "Dubai Airport Free Zone (DAFZ)",
            "Dubai Car and Automotive City Free Zone (DUCAMZ)",
            "Dubai Flower Center Free Zone",
            "Dubai Gold and Diamond Park",
            "Dubai Health Care City (DHCC)",
            "Dubai Industrial City (DIC)",
            "Dubai International Financial Centre (DIFC)",
            "Dubai Internet City (DIC)",
            "Dubai Knowledge Village (KV) (DKV)",
            "Dubai Media City",
            "Dubai Multi Commodities Centre (DMCC)",
            "Dubai Gold and Commodities Exchange (DGCX)",
            "Dubai Silicon Oasis",
            "Dubai Technology and Media Free Zone (TECOM)",
            "Economic Zones World (EZW)",
            "Dubai Auto Zone",
            "Jafza International",
            "Jebel Ali Free Zone (JAFZ)",
            "Dubai Logistics City",
            "ENPARK",
            "Dubai Investment Park",
            "Dubai Aid City",
            "Dubai Auto Parts City",
            "Dubai Biotechnology & Research Park (Dubiotech or Dubai Biotech)",
            "Dubai Carpet Free Zone - Deira",
            "Dubai International Arbitration Center (DIAC)",
            "Dubai Maritime City",
            "Dubai Outsource Zone (DOZ)",
            "Dubai Studio City - Dubai land",
            "Dubai Techno Park (TP)",
            "Dubai Textile Village",
            "Heavy Equipment & Trucks Free Zone",
            "International Media Production Zone",
            "Dubai International Academic City",
            "Jumeirah Lakes Towers Free Zone",
            "Dubai World Central (DWC)",
            "Al Awir Free Zone",
            "Community Development Authority",
            "Dubai Creative Clusters Authority",
            "Dubai World Trade Center Authority",
            "International Humanitarian City",
            "Trakhees",
            "National Industries Complex",
            "Meydan Free Zone",
            "Dubai Academic City",
            "Dubai Design District",
            "Dubai Aviation City Corporation",
            "Dubai South",
            "Dubai Industrial Park",
            "International Free Zone Authority",
            "EXPO City Dubai Authority",
            "Dubai Development Authority"
        ]
    },
    "Fujairah": {
        "Mainland": [
            "Department of Industry and Economy - Fujairah",
            "Dibba Municipality",
            "Fujairah Municipality"
        ],
        "Free Zone": [
            "Fujairah Free Zone (FFZ)",
            "Fujairah Creative City"
        ]
    },
    "Ras Al Khaimah": {
        "Mainland": [
            "Department of Economic Development - Ras Al Khaimah",
            "Ras Al Khaimah Tourism Development Authority"
        ],
        "Free Zone": [
            "RAK Free Trade Zone (RAKFTZ or RAK FTZ)",
            "RAK Investment Authority Free Zone (RAKIA FZ)",
            "RAK Maritime City (RAKMC)",
            "RAK Knowledge Village",
            "Ras Al Khaimah Media Free Zone",
            "RAK Economic Zone Authority (RAKEZ)",
            "RAK Digital Assets Oasis"
        ]
    },
    "Sharjah": {
        "Mainland": ["Department of Economic Development - Sharjah"],
        "Free Zone": [
            "Hamriyah Free Zone",
            "Sharjah Airport International Free Zone (SAIF)",
            "Sharjah Media City Free Zone",
            "Sharjah Publishing City",
            "Sharjah Research Technology and Innovation Park",
            "Sharjah Healthcare City"
        ]
    },
    "Umm Al Quwain": {
        "Mainland": [
            "Department of Economic Development - Umm al-Quwain",
            "Umm Al Quwain Municipality"
        ],
        "Free Zone": [
            "Ahmed Bin Rashid Free Zone (ABRFZ)",
            "Umm Al Quwain Free Trade Zone (UAQFTZ)"
        ]
    }
};
